import constants from 'constants';
import _ from 'lodash';

const {
  ADD_HOSPITAL_SUGGESTIONS,
  NEW_HOSPITAL_SUGGESTION,
  ADD_COUNTY_SUGGESTIONS,
  ADD_SPONSOR_SUGGESTIONS
} = constants;

const suggestions = (suggestions = {
  hospital: { q: '', values: [] },
  county: { q: '', values: [] },
  sponsor: { q: '', values: [] }
}, action) => {
  switch(action.type) {
    case ADD_HOSPITAL_SUGGESTIONS:
      return {
        ...suggestions,
        hospital: {
          ...suggestions.hospital,
          q: action.q,
          values: _.uniq([...suggestions.hospital.values, ...action.suggestions], 'title')
        }
      }
    case NEW_HOSPITAL_SUGGESTION:
      return {
        ...suggestions,
        hospital: {
          ...suggestions.hospital,
          q: action.q,
          values: [...suggestions.hospital.values, action.suggestion]
        }
      }
      break;
    case ADD_COUNTY_SUGGESTIONS:
      return {
        ...suggestions,
        county: {
          ...suggestions.county,
          values: action.suggestions
        }
      }
      break;
    case ADD_SPONSOR_SUGGESTIONS:
      return {
        ...suggestions,
        sponsor: {
          ...suggestions.county,
          values: action.suggestions
        }
      }
      break;
    default:
      return suggestions;
  }
}

export { suggestions };



/** WEBPACK FOOTER **
 ** ./src/reducers/suggestions.js
 **/